import { Button, Col, Input, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 480px;
  align-self: center;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1024px) {
    width: 326px;
    padding: 36px 0 0;
  }

  animation: ${fadeIn} 0.4s linear;
`;

const Verification = ({ data }) => {
  const [code, setCode] = useState(''),
    dispatch = useDispatch(),
    { isMobile } = global;

  useEffect(() => {
    const inputEl = document.getElementById('signup-input');

    inputEl.focus();
  }, []);

  async function handleSubmit() {
    const res = await Api.post(
      '/users/login',
      { email: data.email.trim(), code },
      'signupVerification'
    );

    if (!res) return alert('Code is incorrect.');

    localStorage.setItem('token', res.token);

    dispatch({
      type: 'INITIAL_DATA',
      payload: {
        user: {
          ...res.user,
          fromSignup: true
        }
      }
    });
  }

  return (
    <Wrapper>
      <Col noFlex>
        <Text marg="0 0 38px" bold size={isMobile ? '18px' : '20px'} col={theme.SECONDARY} center>
          VERIFY YOUR ACCOUNT
        </Text>

        <Text size={isMobile ? '18px' : '24px'} center marg="0 0 30px">
          We have sent a code to your email address to verify your account.
        </Text>
      </Col>

      <Col noFlex center>
        <Input
          form
          website
          id="signup-input"
          marg="0 0 20px"
          value={code}
          placeholder="Enter code"
          onChange={({ target }) => setCode(target.value)}
        />

        <Button website action="signupVerification" text="Submit" onClick={handleSubmit} />
      </Col>

      <Col noFlex></Col>
    </Wrapper>
  );
};

export default Verification;
